var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drug"},[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"append-to-body":true,"fullscreen":true,"center":"","modal":_vm.mask,"show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('iframe',{attrs:{"height":"100%","width":"100%","src":"../../../static/js"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8586c20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page1/drug.vue
// module id = null
// module chunks = 